const firebase = require('firebase')
const rebase = require('re-base')

const config = {
    apiKey: "AIzaSyBhiJ7cH4vcU3Lu7-j_M6yR7y5V-Ni2Okc",
    authDomain: "contech-2024.firebaseapp.com",
    projectId: "contech-2024",
    storageBucket: "contech-2024.appspot.com",
    messagingSenderId: "51147699022",
    appId: "1:51147699022:web:26f1f1b6834ab0302de41f",
    measurementId: "G-MBJLYD31RF"
};

const app = firebase.initializeApp(config);
const firebaseConfig = rebase.createClass(app.database())
const firestore = app.firestore()

export const storage = app.storage()
export const base = rebase.createClass(firestore)
export const auth = app.auth()

export default firebaseConfig